module.exports = __webpack_public_path__ + "static/media/logo.4bc79043.png";